// config/AppVersion.js
export const appVersion = 'v1.0.30'; // Versão do aplicativo